/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
  * @typedef {Object} selectionOption
  * @property {Boolean} [includeParents = false] Selections needs to include parents. (not applicable to charts)
  */

/**
 * @class DataPointSelectionsAPI
 * @hideconstructor
 */
define([], () => {

	class DataPointSelectionsAPI {

		/**
		 * @function DataPointSelectionsAPI#getSelection
		 * @public
		 * @description get the selected API that built from the supplied list of itemIds.
		 * 
		 * @param {String[]} itemIds array of item ids to be considered as a tuple and is part of the selection.
		 * @param {selectionOption} [options] selection options to describe the selection
		 * @param {boolean} options.includeParents[includeParents=false]- if includes parents; default to false
		 * @param {boolean} options.ignoreEdgeSelections[ignoreEdgeSelections=false] - if ignores edge selection; default to false
 		 * @return {VisSelectedAPI} api class to check what is selected by the itemIds or null if no selections exist for any of the items.
		 */
		getSelection() {}
	}

	return DataPointSelectionsAPI;
});
